import { useCallback } from 'react';

export const useExternalWindowCommand = () => {
    const execute = useCallback(async ({ json: { src } }) => {
        window.open(encodeURI(src));
    }, []);

    return { execute };
};
